// constants/mktuClasses.js
// Справочник классов МКТУ (Ницская классификация товаров и услуг, редакция 12-2023).
// Источник: WIPO / Роспатент. Полные данные из mktu.info

import mktuRawData from './mktu_data.json';

// Преобразование данных из JSON в нужный формат
export const MKTU_CLASSES = mktuRawData.map((item, index) => {
  const classNumber = parseInt(item.номер);
  const isGoods = classNumber <= 34;
  
  return {
    id: index + 1,
    label: item.номер.padStart(2, '0'),
    category: isGoods ? 'Товары' : 'Услуги',
    description: item.пояснения,
    belongsTo: item.к_классу_относятся || '',
    notBelongsTo: item.к_классу_не_относятся || '',
    items: item.товары || item.услуги || '', // Полный список товаров/услуг
    url: item.url
  };
});
